<!-- Container -->
<div class="kt-container-fluid">
	Page content
</div>
<!-- End of Container -->